import React from 'react';
import { Item } from 'components';

export default ({ data=[] }) => {

  const placeholder = Array.from(Array(4), (a,i)=>`${a}${i}`);

  return (
    <div className="Other-Products">

      <div className="Section-Title">You Might Also Need</div>

      {
        (data.empty()) && placeholder.map(a=> <Item key={a} loading/>)
      }

      { data.slice(0,10).map((a,i) =>
          <Item
            id={a.handle}
            title={a.title}
            brand={a.vendor}
            key={i.toString()}
            image={a.images[0]}
            category={a.category}
            price={a.pricing.price}
          />
        )
      }

    </div>
  )
}
